export default {
  'password.requirement.title': '密码必须满足：',

  'password.requirement.atLeast8Chars': '至少8个字符',
  'password.requirement.atLeast1LowercaseLetter': '包括至少1个小写字母',
  'password.requirement.atLeast1UppercaseLetter': '包括至少1个大写字母',
  'password.requirement.atLeast1Number': '包括至少1个数字',
  'password.requirement.match': '匹配',

  'password.strength': '密码强度',
  'password.strength.weak': '弱',
  'password.strength.medium': '中等',
  'password.strength.strong': '强',
};
